import React from 'react';

/** Wrapper component to use when the app does NOT require cloud authentication. Otherwise use AuthenticatedPage. */
const NoAuthPage = (props: React.PropsWithChildren) => {
    return <>{props.children}</>;
}

export default NoAuthPage;
